var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoSkipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 9.99935C1.66663 5.39685 5.39746 1.66602 9.99996 1.66602C14.6016 1.66602 18.3333 5.39685 18.3333 9.99935C18.3333 14.6018 14.6016 18.3327 9.99996 18.3327C5.39746 18.3327 1.66663 14.6018 1.66663 9.99935ZM9.99996 17.0827C6.32413 17.0827 2.91663 13.6752 2.91663 9.99935C2.91663 6.32352 6.32413 2.91602 9.99996 2.91602C13.6758 2.91602 17.0833 6.32352 17.0833 9.99935C17.0833 13.6752 13.6758 17.0827 9.99996 17.0827ZM9.16663 6.66602C9.16663 6.20602 9.53996 5.83268 9.99996 5.83268C10.46 5.83268 10.8333 6.20602 10.8333 6.66602C10.8333 7.12602 10.46 7.49935 9.99996 7.49935C9.53996 7.49935 9.16663 7.12602 9.16663 6.66602ZM8.74996 8.33268C8.74996 8.33268 5.8333 8.33268 9.99996 8.33268C10.46 8.33268 10.8333 8.70602 10.8333 9.16602V13.3327C10.8333 13.7927 10.46 14.166 9.99996 14.166C9.53996 14.166 9.16663 13.7927 9.16663 13.3327V11.2493V9.99935H8.74996C7.49995 9.99935 7.49995 8.33268 8.74996 8.33268Z",
    fill: "#9B4D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSkipped);
export default __webpack_public_path__ + "static/media/info-skipped.03ee5d703d1e00698e45ce1dcf62af36.svg";
export { ForwardRef as ReactComponent };